import React, { useState } from 'react';
import { Tag, Input, Button, Space, message } from 'antd';
import { PlusOutlined } from '@ant-design/icons';

const TagInput = ({ tags = [], onChange, placeholder = 'Nhập và nhấn Enter', maxTags, disabled }) => {
  const [inputVisible, setInputVisible] = useState(false);
  const [inputValue, setInputValue] = useState('');

  const handleClose = (removedTag) => {
    const newTags = tags.filter((t) => t !== removedTag);
    onChange(newTags);
  };

  const handleInputConfirm = () => {
    if (inputValue && !tags.includes(inputValue)) {
      if (maxTags && tags.length >= maxTags) {
        message.warning(`Tối đa ${maxTags} tags`);
        return;
      }
      onChange([...tags, inputValue]);
    }
    setInputVisible(false);
    setInputValue('');
  };

  const handleKeyDown = (e) => {
    if (e.key === 'Enter') {
      e.preventDefault();
      handleInputConfirm();
    }
  };

  return (
    <div className="tag-input">
      {tags.map((tag) => {
        const isLongTag = tag.length > 20;
        const tagElem = (
          <Tag
            key={tag}
            closable={!disabled}
            onClose={() => handleClose(tag)}
            style={{ marginBottom: 8 }}
          >
            {isLongTag ? `${tag.slice(0, 20)}...` : tag}
          </Tag>
        );
        return tagElem;
      })}
      {inputVisible ? (
        <Input
          type="text"
          size="small"
          style={{ width: 150 }}
          value={inputValue}
          onChange={(e) => setInputValue(e.target.value)}
          onBlur={handleInputConfirm}
          onPressEnter={handleInputConfirm}
          placeholder={placeholder}
          autoFocus
          onKeyDown={handleKeyDown}
        />
      ) : (
        <Tag
          onClick={() => !disabled && setInputVisible(true)}
          style={{
            background: '#fff',
            borderStyle: 'dashed',
            cursor: disabled ? 'not-allowed' : 'pointer',
            marginBottom: 8,
          }}
          icon={<PlusOutlined />}
        >
          {placeholder}
        </Tag>
      )}
    </div>
  );
};

export default TagInput;
